export * from './icon-fail.component'
